import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Edit = () => {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate("");


  
  const handleEdit = e => {
    e.preventDefault();
    axios
      .put(`https://646b154b7d3c1cae4ce32640.mockapi.io/crudapi/${id}`, {
        name,
        age,
        id,
        email
      })
      .then(result => {
        navigate("/read");
      })
      .catch(err => {});
  };

  useEffect(() => {
    setId(localStorage.getItem("id"));
    setName(localStorage.getItem("name"));
    setAge(localStorage.getItem("age"));
    setEmail(localStorage.getItem("email"));
  }, []);
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-4 offset-4 ">
            <h2 className="text-center text-success">Update Data</h2>
            <form
              className=" d-flex flex-column align-items-center"
              onSubmit={handleEdit}
            >
              <label>Name</label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                className="infield"
                placeholder="Name"
              />
              <br />
              <label>Age</label>
              <input
                type="number"
                value={age}
                onChange={e => setAge(e.target.value)}
                className="infield"
                placeholder="Age"
              />
              <br />
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="infield"
                placeholder="Email"
              />
              <br />

              <button className="btn btn-primary">Update Now</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
